"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultOrdersHeader = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../../constants");
const DefaultOrdersHeader = () => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    return (react_1.default.createElement("div", { className: "boutik-customer-account-default-orders-header" },
        react_1.default.createElement("span", { className: "boutik-customer-account-default-orders-header-id" }, t("customerAccount.orders.header.orderId")),
        react_1.default.createElement("span", { className: "boutik-customer-account-default-orders-header-date" }, t("customerAccount.orders.header.date")),
        react_1.default.createElement("span", { className: "boutik-customer-account-default-orders-header-total" }, t("customerAccount.orders.header.total")),
        react_1.default.createElement("span", { className: "boutik-customer-account-default-orders-header-statut" }, t("customerAccount.orders.header.status")),
        react_1.default.createElement("span", { className: "boutik-customer-account-default-orders-header-button" })));
};
exports.DefaultOrdersHeader = DefaultOrdersHeader;
//# sourceMappingURL=DefaultOrdersHeader.js.map